import script from "./SimpleTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleTable.vue?vue&type=script&setup=true&lang=js"

import "./SimpleTable.vue?vue&type=style&index=0&id=3a95260a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a95260a"]])

export default __exports__